export default function StatCard({ label, value, hint, accent = "text-slate-900", icon: Icon, testId }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 hover:border-sky-200 transition-colors" data-testid={testId}>
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-widest text-slate-500">{label}</div>
        {Icon && <Icon size={16} className="text-slate-400" />}
      </div>
      <div className={`mt-3 font-heading text-3xl font-semibold ${accent}`} data-testid={`${testId}-value`}>
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </div>
  );
}
